import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionState } from '../../model/enums/auth-state.enum';
import { fadeInGlideDown, fadeInGlideUp } from '../../../shared/utils/animations';
import { AuthMessageResponse } from '../../model/interfaces/auth-message-response.interface';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [fadeInGlideDown(), fadeInGlideUp()],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit {
  protected authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  readonly icons = {
    paperPlane: 'fa-paper-plane',
  };

  state: ActionState = ActionState.PENDING;
  form!: FormGroup;
  messages: AuthMessageResponse[] = [];

  constructor() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.minLength(3)]),
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.authService.projectName = params.get('project') || '';
    });

    // Pre-fill email field with username from login page (if available)
    if (this.authService.username) {
      this.form.patchValue({ email: this.authService.username });
      // Clear stored username after using it
      this.authService.username = '';
    }
  }

  showConfirmation(): boolean {
    return this.state == (ActionState.SUCCESS || ActionState.FAILURE);
  }

  onSubmit(): void {
    this.authService.setState(this, ActionState.IN_PROGRESS);
    this.authService.forgotPassword(this.form.controls['email']?.value || '').subscribe({
      next: (/*response*/) => {
        this.authService.setState(this, ActionState.SUCCESS);
      },
      error: (message) => {
        this.authService.finalizeAction(this, ActionState.FAILURE, [message.error]);
      },
    });
  }
}
